<template>
    <b-row style="min-height: 681px">
        <b-col sm="12">
            <b-card>
                <b-row class="mt-sm-2">
                    <b-col sm="12">
                        <b-row>
                            <b-col sm="1"></b-col>
                            <b-col sm="5">
                                <span class="pr-">
                                    <strong>* 최근 검색 {{searchSize | numberComma}} 건 까지만 조회 합니다.</strong>
                                </span>
                            </b-col>
                            <b-col sm="2">
                                <b-form-input
                                    id="filter-input"
                                    v-model="filter"
                                    type="search"
                                    placeholder="검색어를 입력해주세요."></b-form-input>
                            </b-col>
                            <b-col sm="2">
                                <b-button v-if="!isDownload"
                                        variant="outline-primary"
                                        style="float: right"
                                        v-on:click="downloadList()">
                                        엑셀 다운로드
                                </b-button>
                                <b-button v-else
                                        variant="outline-primary"
                                        style="float: right; cursor: default" >
                                    <span class="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"></span>
                                        엑셀 다운로드</b-button>
                            </b-col>
                            <b-col md="2">
                                <b-form-group label-cols-sm="5" label="" class="mb-0">
                                <b-form-select
                                    v-model="rowPage"
                                    :options="pageOptions"
                                    v-on:change="findSearch"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>

                    <!-- 로딩 -->
                    <b-col sm="12" v-show="listLoading">
                        <b-row>
                            <b-col sm="5"></b-col>
                            <b-col sm="5" class="pt-5 pb-5">
                                <PulseLoader color="#20a8d8"></PulseLoader>
                            </b-col>
                        </b-row>
                    </b-col>

                    <!-- 목록 -->
                    <b-col sm="12" class="pt-sm-1" v-show="!listLoading">
                        <b-row>
                            <b-col sm="12">
                                <b-table outlined 
                                        :fields="fields"  
                                        :filter="filter"
                                        @filtered="onFiltered"
                                        :items="items"
                                        :busy="items == 0"
                                        :current-page="currentPage"
                                        :per-page="rowPage"
                                        style="min-height: 508px;">
                                        <div slot="table-busy" class="text-center my-2">
                                            <strong>데이터가 없습니다.</strong>
                                        </div>
                                </b-table>
                            </b-col>
                        </b-row>
                    </b-col>

                    <!-- 페이징 -->
                    <b-col sm="12" class="pt-sm-1">
                        <b-row class="pb-sm-2">
                            <b-col sm="12" class="my-1">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="rowPage"
                                :limit="limitPage"
                                align="center"
                                ></b-pagination>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
    name: "searchHistoryList",
    data() {
        return {
            listLoading: false,
            totalRows: 0,
            currentPage: 1,
            limitPage: 10,
            rowPage: 10,
            pageOptions: [10, 30, 50, 100],
            fields: [
                { searchcondition_search_name: { label: "검색어" } },
                { searchcondition_search_user_id: { label: "검색 사용자 ID" } },
                { searchcondition_search_user_name: { label: "검색 사용자 이름" } },
                { searchcondition_clientIp: { label: "검색IP" } },
                { timestamp: { label: "검색일시" } },
            ],
            searchSize: 1000,
            filter: null,
            items: [],
            isDownload: false,
        }
    },
    mounted() {
        this.findSearch();
    },
    methods: {
        findSearch() {
            this.listLoading = true;
            this.$http1
                .get("/search/searchHistoryAdmin?size=" + this.searchSize)
                .then((result) => {
                    const { data } = result;
                    // console.log(result);
                    this.totalRows = data.length;
                    this.items = [];
                    this.items = data;
                    this.listLoading = false;
            });
        },
        downloadList() {
            var config = {
                responseType: 'blob'
            };
            this.isDownload = true;
            this.$http1
                .post("/search/downloadSearchHistoryAdmin?size=" + this.searchSize, null, config)
                .then((result) => {
                    const url = window.URL.createObjectURL(new Blob([result.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    var fileName = "검색히스토리_" + moment().format('YYYYMMDD');
                    link.setAttribute('download', fileName + '.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.isDownload = false;
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
    },
    components: {
        PulseLoader,
    }
}
</script>
<style scoped>
  .mx-datepicker{
    width : 230px !important;
  }

  table tr th, td {
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/views/site/search/component/tabs/searchHistory/SearchHistoryList.vue